import { useMutation } from "react-query";
import { configSrore } from "../configSrore";
import { ERequest } from "../interface";
import Fetch from "../utils/fetch";

export default function useRenameFile(repoId?:number, hash?:string) {
  return useMutation(
    async (values: {
      page: number;
      newName:string;
      callBack?: () => void;
    }) => {
      const { newName } = values;
      await Fetch({
        url: `${configSrore.clasorUrl}files/repository/${repoId}/fileHash/${hash}`,
        method: ERequest.PUT,
        data: {
          newName,
        },
      });
    },
    {
      onSuccess: (_result, values) => {
        const { callBack } = values;
        if (callBack) { callBack(); }
      },
    },
  );
}
